<!--票据打印页面-->
<template>
<a-modal v-model="visible" :title="title" :width="width" switchFullscreen :cancelText="$t('关闭')">
  <template slot="footer">
    <a-button key="close" @click="handleCancel">
      {{ $t('关闭') }}
    </a-button>
  </template>
  <a-spin  :spinning="Loading">
      <template v-if="!Loading">
        <print-pay-daxing-modal v-if="printType === 1" ref="printModal" :model="model"></print-pay-daxing-modal>
        <print-pay-shanyin-modal v-else-if="printType === 2" ref="printModal" :model="model"></print-pay-shanyin-modal>
        <print-hejing-modal v-else-if="printType === 3" ref="printModal" :model="model"></print-hejing-modal>
        <print-shuangyashan-modal v-else-if="printType === 4" ref="printModal" :model="model"></print-shuangyashan-modal>
        <print-pay-tangyuan-modal v-else-if="printType === 5" ref="printModal" :model="model"></print-pay-tangyuan-modal>
        <printPayEMinModal v-else-if="printType === 6" ref="printModal" :model="model"></printPayEMinModal>
        <print-pay-common-modal v-else ref="printModal" :model="model"></print-pay-common-modal>
      </template>
  </a-spin>

</a-modal>
  
</template>
<script>
import moment from "moment"
import { getAction } from '@/api/manage'
import { changeToChinese } from '@/utils/util'
import {isUndefined,isNull} from '@/utils/validate'
import { mapGetters } from 'vuex'
import printPayCommonModal from './printPayCommonModal'
import printPayDaxingModal from './printPayDaxingModal'
import printPayShanyinModal from './printPayShanyinModal'
import printHejingModal from './printHejingModal'
import printShuangyashanModal from './printShuangyashanModal'
import printPayTangyuanModal from './printPayTangyuanModal'
import printPayEMinModal from './printPayEMinModal'
import {payTypeObj} from '@/utils/constants/commonConstant'
import {getUserList} from '@/api/api'
export default {
  filters: {changeToChinese},
  components: {
    printPayCommonModal,
    printPayDaxingModal,
    printPayShanyinModal,
    printHejingModal,
    printShuangyashanModal,
    printPayTangyuanModal,
    printPayEMinModal
  },
    data() {
      const sysOrgCodePrintTypeObj= {
        'A26': 1,
        'A68': 2,
        'A29': 3,
        'B01': 4,
        'B32': 5,
        'A01': 6
      }
        return {
            visible: false,
            title:'',
            sysOrgCodePrintTypeObj,
            Loading: false,
            width:1000,
            model: {},
            url: {
              queryPayDetailInfo: '/jeecg-charge/meter/meterUserPayRecord/queryPayDetailInfo'
            },
            printType: '',
            payType: payTypeObj
        }
    },
    methods: {
        moment,
        ...mapGetters(["nickname", "avatar","userInfo"]),
        edit(record) {
          console.log("打印票据")
            this.title = this.$t('打印预览')
            this.queryUserByKeyId(record)
            this.visible = true;
        },
        queryUserByKeyId(record) {  //缴费前查询
          let params = {}
          params.orderId = record.orderId
          this.Loading = true
          getAction(this.url.queryPayDetailInfo, params).then((res) => {
            if(res.success){
              let model = Object.assign({}, res.result);
              let username = model.updateBy?model.updateBy:model.createBy;
              let that = this;
              let realname = '';
              getUserList({username: username}).then((userRes) => {
                if (userRes.success&&userRes.result.records.length>0) {
                  realname = userRes.result.records[0].realname
                }
              }).finally(() => {
                model.chargeUserName = realname
                this.model = model;
                console.log(this.model)
                if(!isNull(this.model.sysOrgCode)&&this.model.sysOrgCode!='') {
                  let sysOrgCode = this.model.sysOrgCode
                  console.log(sysOrgCode)
                  if(sysOrgCode.length>3) {
                    sysOrgCode= this.model.sysOrgCode.subStr(0,3)
                  }
                  if(!isUndefined(this.sysOrgCodePrintTypeObj[sysOrgCode])) {
                    this.printType = this.sysOrgCodePrintTypeObj[sysOrgCode]
                  }
                }
              })
            }
          }).finally(() => {
            this.Loading = false
          })
        },
        close () {
            this.$emit('close');
            this.printType = ''
            this.visible = false;
        },
        handleCancel () {
            this.close();
        },
    }
}
</script>
<style>
#table td{text-align: center;}
.print-section{
  overflow: auto;
}
</style>